<template>
  <div class="wscn-container">
      <div class="fault-box">
          <div class="four">404!</div>
          <div class="description">暂时未找到您查找的页面</div>
          <div class="description" v-if="personal.msg">可能{{personal.msg}}</div>
      </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
export default {
  name: 'Page404',
  computed: {
    ...mapState(['personal'])
  },
  methods: {
    goHome(){
      this.$router.push({name:"home"})
    }
  }
}
</script>
<style lang="scss" scoped>
.wscn-container{
  width: 100vw;
  height: 100%;
  background-color: #eeeeee;
  .fault-box{
    padding-top: 30vh;
    margin: 0 20px;
    .four{
      font-size: 140px;
      text-align: center;
      color: #333;
    }
    .description{
      text-align: center;
      font-size: 30px;
      color: #333;
      line-height: 60px;
    }

  }
}
.wscn-http404-container{
    width: 100%;
    height: 100%;
  .pic-404{
      width: 100%;
      height: 100%;
    .pic-404__parent{
      width: 100%;
      height: 100%;
    }
  }
  .bullshit__return-home{
    position: fixed;
    cursor:pointer;
    width: 420px;
    height: 100px;
    top: 72%;
    left: 22%;
    cursor:pointer;
  }
}
</style>
